import ToastEventBus from 'primevue/toasteventbus'
import type { ToastMessageOptions } from 'primevue/toast'

export const useToastService = () => {
  const showToast = (message: ToastMessageOptions) => {
    ToastEventBus.emit('add', message)
  }

  return { showToast }
}
